import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import Base from "components/Base";
import BaseListagem from "components/BaseListagem";
import ModalViagemDespesaEditar from "components/modal/viagem/ModalViagemDespesaEditar";
import { BaseModel } from "model/BaseModel";
import Pageable from "model/page/Pageable";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemDespesaAprovacao from "model/viagem/ViagemDespesaAprovacao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import { useSearchParams } from "react-router-dom";
import ViagemAprovacaoService from "service/viagem/ViagemAprovacaoService";
import ViagemDespesaAprovacaoService from "service/viagem/ViagemDespesaAprovacaoService";
import { converterData } from "utils/convert";

const viagemDespesaAprovacaoService = new ViagemDespesaAprovacaoService();

export default function ViagemDespesaAprovacaoListagem() {

    const [queryParameters] = useSearchParams();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [titulo, setTitulo] = useState<string>('Aprovar despesas de viagens');
    const [rows, setRows] = useState<BaseModel[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "viagemDespesa.dataDespesa,DESC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [urlOpened, setUrlOpened] = useState<string>('');

    const [dialogAlterar, setDialogAlterar] = useState<{ visible: boolean, despesa: ViagemDespesa }>({ visible: false, despesa: new ViagemDespesa() });
    const [dialogImagens, setDialogImagens] = useState<{ visible: boolean, despesa: ViagemDespesa }>({ visible: false, despesa: new ViagemDespesa() });

    useEffect(() => {
        if (filtrando) {
            viagemDespesaAprovacaoService
                .pesquisar(pageable)
                .then(lista => {
                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando]);

    useEffect(() => {
        setFiltrando(true);
    }, [pageable]);

    const onPage = (event: DataTableStateEvent) => {
        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
    };

    function getHeader() {

        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                <div></div>
                <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{titulo}</span>
                <div >
                </div>


            </div>
        )
    }

    const aprovar = (id: number) => {
        viagemDespesaAprovacaoService.aprovar(id).then(() => {
            msgSucesso("Sucesso", "Despesa aprovada com sucesso!");
            setFiltrando(true);
        }).catch((err) => {
            if (err && err.data && err.data.message) {
                msgAlerta("Atenção", err.data.message);
            } else {
                msgErro("Erro", "Erro ao aprovar despesa!");
            }
        })
    }
    const rejeitar = (id: number) => {
        viagemDespesaAprovacaoService.rejeitar(id).then(() => {
            msgSucesso("Sucesso", "Despesa rejeitada com sucesso!");
            setFiltrando(true);
        }).catch((err) => {
            if (err && err.data && err.data.message) {
                msgAlerta("Atenção", err.data.message);
            } else {
                msgErro("Erro", "Erro ao aprovar despesa!");
            }
        })
    }



    return (
        <Base tituloPagina={titulo}>
            <div className="card" style={{ marginTop: 8 }}>
                {dialogImagens.visible ? <Dialog header="Imagens" visible={dialogImagens.visible} style={{ width: '50vw' }} onHide={() => { setDialogImagens({ visible: false, despesa: new ViagemDespesa() }) }}>
                    <div style={{ display: "flex" }}>

                        {dialogImagens.despesa.imagens && dialogImagens.despesa.imagens.map((imagem, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                                    <div key={`img${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                        <a className='p-lightbox-image-target' style={{ marginLeft: 'auto', cursor: 'pointer', marginRight: 'auto', width: 128, textAlign: 'center' }} onClick={() => {
                                            setTimeout(() => {
                                                setPhotoOpen(true)
                                                setUrlOpened(imagem.url)

                                            }, 100)
                                        }}>
                                            <img style={{ maxHeight: 128, maxWidth: 128 }} src={imagem.url} title={imagem.nome} />
                                        </a>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Dialog> : null}
                {
                    photoOpen && (
                        <Lightbox
                            mainSrc={urlOpened}
                            onCloseRequest={() => setPhotoOpen(false)}
                            reactModalStyle={{ overlay: { zIndex: 9999 } }}
                        />
                    )
                }
                {dialogAlterar.visible ? <ModalViagemDespesaEditar
                    viagemDespesa={dialogAlterar.despesa}
                    visible={dialogAlterar.visible}
                    onHide={() => setDialogAlterar({ visible: false, despesa: new ViagemDespesa() })} /> : null}
                <DataTable
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    currentPageReportTemplate="{first} - {last} de {totalRecords}"
                    header={getHeader()}
                    value={rows} lazy dataKey="id" paginator
                    first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                    loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                    emptyMessage="Nenhum registro encontrado"
                >
                    <Column field="viagemDespesa.viagem.codigo" header="Nr." />

                    <Column field="viagemDespesa.viagem.usuarioSolicitante.nome" header="Solicitante" />
                    <Column field="viagemDespesa.viagem.centroCusto.nome" header="Centro de custo" />
                    <Column field="viagemDespesa.viagem.itinerario" header="Itinerário" />
                    <Column field="viagemDespesa.tipo.nome" header="Tipo" />
                    <Column field="viagemDespesa.observacao" header="Observação" />
                    <Column field="viagemDespesa.dataDespesa" header="Dt. Despesa" body={(rowData: ViagemDespesaAprovacao) => converterData(rowData?.viagemDespesa?.dataDespesa)} />
                    <Column
                        field="viagemDespesa.valorAlerta" header="Valor alerta"
                        body={(rowData: ViagemDespesaAprovacao) => rowData?.viagemDespesa?.valorAlerta?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || ""}
                    />
                    <Column
                        field="viagemDespesa.valor" header="Valor Despesa"
                        body={(rowData: ViagemDespesaAprovacao) => rowData?.viagemDespesa?.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || ""}
                    />
                    <Column header="Imagens" body={(rowData) => <Button icon="pi pi-images" onClick={() => setDialogImagens({ visible: true, despesa: rowData?.viagemDespesa })} />} />
                    <Column body={(rowData) => <Button icon={<FontAwesomeIcon icon="edit" />} onClick={() => setDialogAlterar({ visible: true, despesa: rowData?.viagemDespesa })} />} />
                    <Column body={(rowData: ViagemDespesaAprovacao) => <div style={{ display: "flex", flexDirection: "row", columnGap: "8px" }}>
                        <Button icon="pi pi-check" className="p-button-success" onClick={() => aprovar(rowData?.viagemDespesa?.id || 0)} label="Aprovar" />
                        <Button icon="pi pi-times" className="p-button-danger" onClick={() => rejeitar(rowData?.viagemDespesa?.id || 0)} label="Rejeitar" />
                    </div>} />
                </DataTable>
            </div>
        </Base>
    )
}
